// ============================================================
// Role Definitions
// ============================================================

export const ROLES = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  ORGANIZATION_ADMIN: 'organization_admin',
  PRINCIPAL: 'principal',
  RECEPTION: 'reception',
  ACCOUNTANT: 'accountant',
  TEACHER: 'teacher',
});

export const ROLE_LABELS = Object.freeze({
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.ORGANIZATION_ADMIN]: 'Organization Admin',
  [ROLES.PRINCIPAL]: 'Principal',
  [ROLES.RECEPTION]: 'Reception',
  [ROLES.ACCOUNTANT]: 'Accountant',
  [ROLES.TEACHER]: 'Teacher',
});

export const ROLE_LIST = Object.values(ROLES);
